export default "__VITE_ASSET__B4V3SnVV__"